<template>
    <div class="home-wrapper flex-height-max">
        <div class="home-wrapper-container">
            <div v-if="progress_bar_percentage > 0">
                <div class="progress">
                    <div class="progress-bar bg-success" role="progressbar" v-bind:style="'width:'+progress_bar_percentage+'%;'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{progress_bar_text}}</div>
                </div>
                <div style="text-align: left; font-size: 12px;">Setup progress</div>
            </div>
            <template>
                <div class="header-home">
                    Activate your 14 days free trial
                </div>

                <div class="flex-height-max flex-row flex-wrap-mobile">
                    <div class="content" style="width: 100%;">
                        <div class="subscription__trial" style="font-size: 14px;">
                            <div style="padding-top: 5px;">
                                💰 You will not be charged until after your free trial ends
                            </div>
                            <div style="padding: 5px 0;">
                                ✉️ We will send you a reminder email before a free trial ends
                            </div>
                        </div>
                        <div class="subscription" style="font-size: 14px;">
                            <custom-input
                                name="selected_plan"
                                type="select"
                                v-model="selected_plan"
                                value_name="name"
                                :select_options="plan_options"
                                :onSelect="getPlanInfo"
                                styled="standard"
                            ></custom-input>
                            <template>
                                <template v-if="selected_plan.name === 'Basic Plan'">
                                    <ul>
                                        <li>Unlimited Ads Accounts</li>
                                        <li>Up to 5,000 Ad Clicks per month</li>
                                        <li>Cancel risk-free within the first 14 days</li>
                                    </ul>
                                </template>
                                <template v-else-if="selected_plan.name === 'Standard Plan'">
                                    <ul>
                                        <li>Unlimited Ads Accounts</li>
                                        <li>Up to 10,000 Ad Clicks per month</li>
                                        <li>Cancel risk-free within the first 14 days</li>
                                    </ul>
                                </template>
                                <template v-else-if="selected_plan.name === 'Professional Plan'">
                                    <ul>
                                        <li>Unlimited Ads Accounts</li>
                                        <li>Up to 100,000 Ad Clicks per month</li>
                                        <li>Cancel risk-free within the first 14 days</li>
                                    </ul>
                                </template>

                                <div class="subscription__billing space-between">
                                    <div style="white-space: nowrap; font-weight: bold;">Billing cycle</div>
                                    <div class="radio-buttons">
                                        <div class="ml-2">
                                            <input type="radio" id="monthly" name="price_time" :value="monthly_price.price_id" v-model="price_id">
                                            <label for="monthly">Monthly</label>
                                        </div>
                                        <div class="ml-2">
                                            <input type="radio" id="annual" name="price_time" :value="annual_price.price_id" v-model="price_id">
                                            <label for="annual">Annual (save 20%)</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="space-between price" style="font-size: 14px;">
                                    <div>Price</div>
                                    <div>${{price}}</div>
                                </div>
                                <div class="space-between green total_price" style="font-size: 16px;">
                                    <div>TOTAL DUE NOW</div>
                                    <div>$0</div>
                                </div>
                                <form method="POST" action="/start-new-subscription">
                                    <input type="hidden" id="price_id" name="price_id" v-bind:value="price_id"/>
                                    <input type="hidden" id="plan_id" name="plan_id" v-bind:value="selected_plan.plan_id"/>
                                    <button class="mt-2 btn w-100" type="submit">NEXT</button>
                                </form>
                                <div style="display: flex; justify-content: center; margin-top: 20px;">
                                    <img class="safe_checkout_desktop" src="/images/Safe_checkout.jpg" alt="Safe checkout"
                                         style="max-width: 393px; width: 100%; height: auto; align-self: flex-start;"
                                    >
                                    <img class="safe_checkout_mobile" src="/images/Safe_checkout_mobile.jpeg" alt="Safe checkout"
                                         style="max-width: 393px; width: 100%; height: auto; align-self: flex-start;"
                                    >
                                </div>
                                <div style="font-size: 12px; color: #636b6f; text-align: center; margin-top: 5px;">
                                    <span>The prices are in US dollars</span>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="content-right-side">
                        <img class="right-img" src="/images/Add_Google_A_Account.jpg" alt="add account">
                        <div style="margin-top: 10px; color:#0573d9;">💡 Pro tip: Protect unlimited number of Google Ads accounts for free within your dashboard</div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import VuePreloaders from 'vue-preloaders';
    import Infinite from '../shared/preloader.vue';
    Vue.use(VuePreloaders, {
        "component": Infinite,
        "overlayStyle": {
            "background": "rgba(0,0,0,.2)",
            "opacity": 1
        }
    });

    export default {
        props: ['plan', 'release', 'progress_bar_percentage', 'progress_bar_text'],
        data: function () {
            return {
                price_id: '1',
                monthly_price: {price_id: '1', cost: 0},
                annual_price: {price_id: '2', cost: 0},
                selected_plan: '',
                plan_options: this.release === 'production' ? [
                    {name: 'Basic Plan', plan_id: 'prod_IX9Dq2mkTkVMJt'},
                    {name: 'Standard Plan', plan_id: 'prod_IXAcu57fcVsXGD'},
                    {name: 'Professional Plan', plan_id: 'prod_IXAdp5ytUf571U'},
                ] : [
                    {name: 'Basic Plan', plan_id: 'prod_IZ3QeJMZncagRc'},
                    {name: 'Standard Plan', plan_id: 'prod_IZ3tTq6HQezz2d'},
                    {name: 'Professional Plan', plan_id: 'prod_J5XEVxCCeJFuh6'},
                ],
                is_mobile: window.innerWidth < 992,

                preloader: () => {},
            }
        },
        methods: {
            startPreloader() {
                this.preloader = this.$preloaders.open(/*{ options }*/);
            },
            stopPreloader() {
                this.preloader();
            },
            getPlanInfo(){
                this.startPreloader();
                axios.get('/get-plan-info?plan='+this.selected_plan.plan_id)
                    .then(data => {
                        this.monthly_price = data.data.monthly_price;
                        this.annual_price = data.data.annual_price;
                        this.price_id = data.data.monthly_price.price_id;
                        this.stopPreloader();
                    })
                    .catch(err => console.log('err', err));
            }
        },
        computed: {
            price: function (){
                if(this.price_id === this.annual_price.price_id) return this.annual_price.cost;
                else return this.monthly_price.cost;
            },
        },
        mounted() {
            const plan_id = this.plan;
            const option = this.plan_options.filter(function (value) {
                return value.plan_id === plan_id;
            });
            if(option.length > 0) this.selected_plan = option[0];
            this.getPlanInfo();
        }
    }
</script>
